// extracted by mini-css-extract-plugin
export default {"search":"style_search__nVL3Y","input":"style_input__oBTNz"};